var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.472 10.1c1.196 0 2.31.556 3.107 1.486.794.926 1.222 2.155 1.222 3.414v2.9H12V15c0-.863-.295-1.669-.787-2.243-.489-.57-1.12-.857-1.741-.857H4.329c-.622 0-1.252.287-1.741.857-.493.574-.787 1.38-.787 2.243v2.9H0V15c0-1.259.428-2.488 1.222-3.414.797-.93 1.91-1.486 3.107-1.486h5.143z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9 0a4.25 4.25 0 11-2.852 7.4l-.152-.145a4.25 4.25 0 01-.146-5.858l.146-.152A4.25 4.25 0 016.9 0zm0 1.8a2.45 2.45 0 100 4.9 2.45 2.45 0 000-4.9z",
    fill: "#000"
  })));
}
export default SvgIconGlobalProfile;